// extracted by mini-css-extract-plugin
export default {"bannerBottom":"Home_bannerBottom__UP0IU","imageBannerBottom":"Home_imageBannerBottom__NtB53"};